import { useQueries } from '@tanstack/react-query'

import type { ImageEntity } from 'common/components/images/api/api'
import { useAppSelector } from 'common/hooks/redux'
import { useSelectedComponentElement } from 'features/unifiedFlow/contentPage/hooks'

import { getInitialImageIds } from '../../helpers'
import { getImageById } from '../api'
import { imagesKeys } from '../queryKeys'

const useGetImageByIdQueries = () => {
  const { data: selectedElement } = useSelectedComponentElement()
  const accountId = useAppSelector((state) => state.authStates.accountId)

  // TODO: This hook will be modified in COS-463, and a parameter will be added to the query params with the IDs it should return.
  const images = useQueries({
    queries: getInitialImageIds(selectedElement).map((imageId) => {
      return {
        queryKey: imagesKeys.byImageId(accountId, imageId!),
        queryFn: () => getImageById(accountId, imageId!),
        enabled: !!accountId && !!imageId && !!selectedElement,
      }
    }),
  })

  return images.reduce<{
    data: (ImageEntity | undefined)[]
    isLoading: boolean
    isError: boolean
  }>(
    (acc, { data, isLoading, isError }) => {
      acc.data.push(data)
      acc.isLoading = acc.isLoading || isLoading
      acc.isError = acc.isError || isError
      return acc
    },
    { data: [], isLoading: false, isError: false }
  )
}

export default useGetImageByIdQueries
